export const Color = {
    primary: '#5045E5',
    secondary: '#3B8D0A',
    white: '#FFF',
    black: '#000',
    borderColor: '#C4C4C4',
    grey: '#00000099',
    red: "#E10101",
    greyBg: "#7E889F",
    datatableHeaderBg: '#F1F4F9'
}